<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table table-data table-striped mg-b-0">
        <thead>
          <tr>
            <th>{{$t("dashboard.公告标题")}}</th>
            <th class=" wd-lg-150">{{$t("dashboard.类型")}}</th>
            <th class=" wd-lg-200">{{$t("dashboard.发布日期")}}</th>
            <th class="wd-lg-100">{{$t("dashboard.操作")}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id" @click="modelOpen(item)">
            <td class=" valign-middle">
              <span class="tx-ellipsis3" :class="colorStyle[item.titleColor]">{{item.title}}</span>
            </td>
            <td>
              <span>{{$t(noticeTypeArr[item.type])}}</span>
            </td>
            <td>
              <span>{{item.timePublished | dateFormat}}</span>
            </td>
            <td>
              <a class=" tx-info " href="javascript:;">{{$t("dashboard.查看详情")}}</a>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="4">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{$t("dashboard.没有符合条件的公告")}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['items', 'noticeTypeArr', 'first_loading'],
  data(){
    return {
      colorStyle: {
        1: 'tx-white',
        2: 'tx-warning',
        3: 'tx-danger'
      }
    }
  },
  filters: {
    dateFormat(val){
      return moment(val,  "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm");
    }
  },
  methods:{
    modelOpen(item){
      this.$emit('openNoticeView', item);
    }
  }
}
</script>

